import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  VStack,
  Text,
  useColorModeValue,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import API from "../../context/API";

const StoresDropDown = ({ onOptionSelect, merchantId, role }) => {
  const [selectedOption, setSelectedOption] = useState("Stores");
  const [stores, setStores] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const fetchStore = async () => {
    try {
      let res;
      if (role === "admin") {
        res = await API.get(`/stores/by-merchant/${merchantId}`);
      } else {
        const token = localStorage.getItem("access_token");
        res = await API.get("/stores", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }

      setStores(res.data.data || []);
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
  };

  useEffect(() => {
    fetchStore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantId, role]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    // Add event listener to detect clicks outside
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {
    
    if(selectedOption === option.name){
      onOptionSelect({
        id:""
      })
      console.log("slected option",selectedOption,option.name)
      setSelectedOption("Stores")
      setIsDropdownOpen(false)
      return
      
    }
    setSelectedOption(option.name);
    setIsDropdownOpen(false);

    // Pass the selected option back to the parent
    onOptionSelect(option);
  };

  const listBg = useColorModeValue("blue.50", "gray.600");
  const containerBg = useColorModeValue("white", "gray.700");

  // Responsive styles using useBreakpointValue
  const buttonWidth = useBreakpointValue({ base: "100%", sm: "150px", md: "180px" });
  const dropdownMaxHeight = useBreakpointValue({ base: "200px", md: "300px" });
  const buttonPaddingX = useBreakpointValue({ base: 2, sm: 4, md: 4 });

  return (
    <Box position="relative" ref={dropdownRef} width={{ base: "100%", sm: "auto" }}>
      <Button
        onClick={() => setIsDropdownOpen((prev) => !prev)}
        rightIcon={
          isDropdownOpen ? (
            <FaChevronUp color="#718096" />
          ) : (
            <FaChevronDown color="#718096" />
          )
        }
        variant="outline"
        width={buttonWidth} // Responsive width
        color="gray.800"
        fontWeight="medium"
        px={buttonPaddingX} // Responsive padding
        py={2} // Consistent vertical padding
        cursor="pointer"
        borderRadius="md"
        boxShadow="sm"
        textAlign="left" // Ensure text aligns to the left
      >
        <Text
          noOfLines={1}
          color="gray.500"
          flex="1" // Ensures the text takes up available space
          fontSize={{ base: "sm", md: "md" }}
        >
          {selectedOption}
        </Text>
      </Button>
      {isDropdownOpen && (
        <VStack
          position="absolute"
          top="100%"
          left={0}
          minWidth="100%" // Ensure dropdown is at least as wide as the button
          width="auto" // Allow it to expand based on content
          maxWidth="100%" // Prevent exceeding the button's width
          maxHeight={dropdownMaxHeight} // Responsive max height
          bg={containerBg}
          boxShadow="md"
          borderRadius="md"
          mt={1}
          spacing={0}
          zIndex={10}
          overflowY="auto"
          // Hide scrollbar using CSS
          css={{
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          {stores.map((option) => (
            <Box
              key={option.id}
              width="100%" // Full width to match the dropdown
              py={2}
              px={4}
              textAlign="left"
              cursor="pointer"
              bg={
                selectedOption === option.name ? listBg : "transparent"
              }
              color={
                selectedOption === option.name ? "blue.500" : "inherit"
              }
              fontWeight={
                selectedOption === option.name ? "bold" : "normal"
              }
              _hover={{ bg: listBg }}
              onClick={() => handleOptionClick(option)}
              whiteSpace="nowrap" // Prevent text wrapping
              fontSize={{ base: "sm", md: "md" }} // Responsive font size
            >
              {option.name}
            </Box>
          ))}
        </VStack>
      )}
    </Box>
  );
};

export default StoresDropDown;
